import "@assets/css/bootstrap-grid.css";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@components/ui/tabs";
import { useHandleAction } from "@utils/hook/index.hook";
import { Camera, MessageCircle } from "lucide-react";
import React from "react";
import DescriptionTestimonialForm from "./description.form";
import VideoTestimonialForm from "./video.form";

const TestimonialForm: React.FC = () => {
  const { searchParams, setSearchParams } = useHandleAction({});
  return (
    <>
      <Tabs
        defaultValue={searchParams.get("tab") || "description"}
        className="w-full mt-6"
      >
        <TabsList className=" w-full h-fit bg-transparent flex mb-12">
          <TabsTrigger
            onClick={() => {
              searchParams.set("tab", "description");
              setSearchParams(searchParams);
            }}
            value="description"
            className="rounded-l-xl"
          >
            <MessageCircle />
            Description
          </TabsTrigger>
          <TabsTrigger
            onClick={() => {
              searchParams.set("tab", "video");
              setSearchParams(searchParams);
            }}
            value="video"
            className="rounded-r-xl"
          >
            <Camera /> Video
          </TabsTrigger>
        </TabsList>
        <TabsContent className="mt-10" value="description">
          <DescriptionTestimonialForm />
        </TabsContent>
        <TabsContent className="mt-10" value="video">
          <VideoTestimonialForm />
        </TabsContent>
      </Tabs>
    </>
  );
};

export default TestimonialForm;
